<template>
    <div>
        <div class="container-fluid mt-45">
            <div class="row">
                <div class="col-md-6">
                    <Breadcrumbs />
                </div>

                <div class="col-md-6 text-right">
                    <button @click="cancelTest()" class="btn btn-danger btn-cancel-test btn-block-mobile btn-lg lg-shadow mt-4 mt-md-0">Cancel test</button>
                </div>
            </div>
        </div>

        <div class="container mt-4">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-8">
                    <div class="card border-0 shadow">
                        <div class="card-body py-5 px-55">
                            <h2>Where would you like the device delivered?</h2>
                            
                            <div class="mt-45">
                                <button @click="confirmPatientAddress()" class="btn btn-success btn-block btn-lg lg-shadow px-0">Patient's address</button>
                                
                                <button @click="confirmCollectionPoint()" class="btn btn-primary btn-block btn-lg lg-shadow mt-4 px-0">Collection point</button>

                                <router-link :to="{name: 'TestDetails'}" class="btn btn-cancel btn-block btn-lg lg-shadow mt-4 px-0">Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import CancelTestModalComponent from '@/components/modals/CancelTestModalComponent.vue'
export default {
    name: 'Location',

    components: {
        Breadcrumbs
    }, 

    data() {
        return {
            CancelTestModalComponent
        }
    },

    mounted() {
        if(!this.patientName && !this.patientId && !this.patientTitle && !this.testDueDate) {
            return this.$router.push({name: 'Dashboard'})
        }
    },

    computed: {
        ...mapGetters({
            patientName: 'TestStore/GetPatientName',
            patientId: 'TestStore/GetPatientId',
            patientTitle: 'TestStore/GetPatientTitle',
            testDueDate: 'TestStore/GetDueDate',
        })
    },

    methods: {
        ...mapActions({
            setDeliveryMethodInTestStoreAction: 'TestStore/SetDeliveryMethod',
            setShippingAddressTypeInTestStoreAction: 'TestStore/SetShippingAddressType'
        }),

        cancelTest() {
            this.$modal.show(CancelTestModalComponent, {}, {width: '400px'});
        },

        async confirmPatientAddress() {
            await this.setDeliveryMethodInTestStoreAction(1)
            await this.setShippingAddressTypeInTestStoreAction(0)

            return this.$router.push({name: 'ConfirmDeliveryAddress'})
        },

        async confirmCollectionPoint() {
            await this.setDeliveryMethodInTestStoreAction(2)
            await this.setShippingAddressTypeInTestStoreAction(1)

            return this.$router.push({name: 'CollectionPoint'})
        },
    }
}
</script>
